import BaseCommand from "@/models/api/commands/BaseCommand";
import { TRADE_TERM_APPLY_TO } from "@/static/tradeTermApplyToTypes";

export interface ComplementAmountToAllParams {
  ApplyTo: TRADE_TERM_APPLY_TO; //0;
  CalculatedFrom: TRADE_TERM_APPLY_TO; // 0;
  Currency: string; // "PLN";
  IsHidden: boolean; // false;
  IsPercentage: boolean; // false;
  Name: string; // "test";
  PriceModifierToRootItem: boolean; // false;
  Quantity: number; // 1;
  Type: number; // 1; //pobrać przez api
  SeparateItem: boolean; // false;
  ServiceTypeId: number | null; // 370; //pobrać przez api
  Value: number; // "1.00";
}

export class ComplementAmountToAllCommand extends BaseCommand {
  CommandName = "ComplementAmountToAll";
  Command: ComplementAmountToAllParams;
  constructor(
    sessionId: string,
    operationId: string,
    params: ComplementAmountToAllParams,
    afterExecuteCallback?: (result: unknown) => void
  ) {
    super(sessionId, operationId, afterExecuteCallback);
    this.Command = params;
  }
}
